export default __webpack_public_path__ + "4dd20ef49b5c73230fdc79fe8859d06b.webp";